// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + "EndCallScreen" + "." + "50c4b806" + ".chunk.css";
};